/* eslint-disable @typescript-eslint/no-explicit-any */
import { css } from 'styled-components';

type Media = {
  [key: string]: any;
};

const breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1700,
};

const media: Media = Object.keys(breakpoints).reduce((accumulator, label) => {
  accumulator[label] = (...args) => css`
    @media (min-width: ${breakpoints[label]}px) {
      ${css(...(args as [any]))};
    }
  `;
  accumulator[label].down = (...args) => css`
    @media (max-width: ${breakpoints[label] - 1}px) {
      ${css(...(args as [any]))};
    }
  `;
  accumulator[label].up = (...args) => css`
    @media (min-width: ${breakpoints[label] + 1}px) {
      ${css(...(args as [any]))};
    }
  `;

  return accumulator;
}, {});

function matchBreakpoint(breakpoint: string): boolean {
  return window.matchMedia(`(min-width: ${breakpoints[breakpoint]}px)`).matches;
}

function matchBreakpointDown(breakpoint: string): boolean {
  return window.matchMedia(`(max-width: ${breakpoints[breakpoint] - 1}px)`).matches;
}

const matchMedia = Object.keys(breakpoints).reduce((accumulator, label) => {
  accumulator[label] = (...args) => {
    if (matchBreakpoint(label)) {
      return args[0];
    }
    return {};
  };
  return accumulator;
}, {});

const matchMediaDown = Object.keys(breakpoints).reduce((accumulator, label) => {
  accumulator[label] = (...args) => {
    if (matchBreakpointDown(label)) {
      return args[0];
    }
    return {};
  };
  return accumulator;
}, {});

export { media, breakpoints, matchMedia, matchMediaDown, matchBreakpointDown, matchBreakpoint };
